import { IYoutubeSearchResult } from 'motw_core/YouTube/IYoutubeSearchResult';
import * as React from 'react';
import { ShowSingleYoutubeSearchResult } from 'source/app/presentation/MainPanel/DevTools/Youtube/Search/Results/SingleResult/ShowSingleYoutubeSearchResult';

export function ShowYoutubeSearchResults({
	searchResults
}: {
	searchResults: IYoutubeSearchResult[];
}) {
	if (!searchResults) {
		return null;
	}

	return (
		<div>
			{searchResults.map((searchResult, index) => (
				<ShowSingleYoutubeSearchResult
					searchResult={searchResult}
					key={index}
				/>
			))}
		</div>
	);
}
